const DB_NAME = 'partner';
const DB_VERSION = 2;
const TABLES = ['international', 'hongkong', 'domestic', 'payment'];

let dbInstance = null;

function openDb() {
  return new Promise((resolve, reject) => {
    if (dbInstance) return resolve(dbInstance);

    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onerror = () => reject(request.error);
    request.onsuccess = () => {
      dbInstance = request.result;
      resolve(dbInstance);
    };

    request.onupgradeneeded = () => {
      const db = request.result;
      TABLES.forEach((table) => {
        if (!db.objectStoreNames.contains(table)) {
          db.createObjectStore(table, { keyPath: 'id', autoIncrement: true });
        }
      });
    };
  });
}

function getStore(storeName, mode = 'readonly') {
  return openDb().then((db) => {
    const tx = db.transaction(storeName, mode);
    return tx.objectStore(storeName);
  });
}

const localDB = {
  async save(table, data) {
    const db = await openDb();
    const tx = db.transaction(table, 'readwrite');
    const store = tx.objectStore(table);

    return new Promise((resolve, reject) => {
      const getAllReq = store.getAll();
      getAllReq.onsuccess = () => {
        const existing = getAllReq.result[0] || {};
        const merged = { ...existing, ...data };

        // Simpan data (pakai existing ID jika ada, atau biarkan autoIncrement)
        const request = existing.id
          ? store.put({ ...merged, id: existing.id })
          : store.add(merged);

        request.onsuccess = () => resolve(merged);
        request.onerror = () => reject(request.error);
      };
      getAllReq.onerror = () => reject(getAllReq.error);
    });
  },

  async getAll(table) {
    const store = await getStore(table);
    return new Promise((resolve, reject) => {
      const request = store.getAll();
      request.onsuccess = () => resolve(request.result);
      request.onerror = () => reject(request.error);
    });
  },

  async getByField(table, field, value) {
    const store = await getStore(table);
    const result = [];

    return new Promise((resolve, reject) => {
      const request = store.openCursor();
      request.onerror = () => reject(request.error);
      request.onsuccess = (e) => {
        const cursor = e.target.result;
        if (cursor) {
          if (cursor.value[field] === value) {
            result.push(cursor.value);
          }
          cursor.continue();
        } else {
          resolve(result);
        }
      };
    });
  },

  async clear(table) {
    const store = await getStore(table, 'readwrite');
    return new Promise((resolve, reject) => {
      const request = store.clear();
      request.onsuccess = () => resolve(true);
      request.onerror = () => reject(request.error);
    });
  },

  async deleteDatabase() {
    return new Promise((resolve, reject) => {
      if (dbInstance) {
        dbInstance.close();
        dbInstance = null;
      }
      const request = indexedDB.deleteDatabase(DB_NAME);
      request.onsuccess = () => resolve(true);
      request.onerror = () => reject(request.error);
      request.onblocked = () =>
        console.warn('Delete blocked: Please close other tabs using this DB.');
    });
  }
};

export { localDB };
